import { render, staticRenderFns } from "./AdminLeaderboards.vue?vue&type=template&id=733ccbe8&scoped=true"
import script from "./AdminLeaderboards.vue?vue&type=script&lang=js"
export * from "./AdminLeaderboards.vue?vue&type=script&lang=js"
import style0 from "./AdminLeaderboards.vue?vue&type=style&index=0&id=733ccbe8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733ccbe8",
  null
  
)

export default component.exports